import Types from "./Types";

const INITIAL_STATE = {
  buckets: [],
  tag: {},
  isLoading: false,
  count: "",
};

export default function superadminBuckets(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_BUCKETS_SUCCESS: {
      return {
        ...state,
        buckets: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_BUCKET_SUCCESS: {
      return {
        ...state,
        tag: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_BUCKET_SUCCESS: {
      let data = payload.data;
      const buckets = state.buckets;
      let idx = 0;
      buckets.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      buckets[idx] = data;
      return {
        ...state,
        buckets: buckets,
      };
    }
    case Types.ENABLE_SUPERADMIN_BUCKET_SUCCESS: {
      let data = payload.id;
      const buckets = state.buckets;
      let idx = 0;
      buckets.forEach((table, index) => {
        if (table.id === data) {
          idx = index;
          return;
        }
      });

      buckets[idx].enable = payload.formData?.enable == 1 ? true : false;
      return {
        ...state,
        buckets: buckets,
      };
    }
    // create
    case Types.CREATE_SUPERADMIN_BUCKET_SUCCESS: {
      const data = payload.data.data;
      return {
        ...state,
        buckets: [...state.buckets, data],
      };
    }
    case Types.ADD_SUPERADMIN_BUCKETS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_BUCKET_SUCCESS: {
      const newbuckets = state.buckets.filter((item) => item.id !== payload);
      return {
        ...state,
        buckets: newbuckets,
      };
    }
    case Types.RESTRICT_SUPERADMIN_BUCKET_SUCCESS: {
      let data = payload.result.data.data;
      const buckets = state.buckets;
      let idx = 0;
      buckets.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });
      buckets[idx].active = data.active;
      return {
        ...state,
        buckets: buckets,
      };
    }
    default: {
      return state;
    }
  }
}
